import {create, ifjs} from "../../fjsc/src/f2.ts";
import {Generics} from "./generics.ts";
import {FJSC} from "../../fjsc";
import {InputType} from "../../fjsc/src/Types.ts";
import {compute, Signal, signal} from "../../fjsc/src/signals.ts";
import {SearchResult} from "../models/SearchResult.ts";
import {target} from "../functions/templates.ts";
import {Api} from "../api/api.ts";
import {Search} from "./search.ts";

export class Home {
    static page() {
        const search = signal("");
        const tracks = signal<SearchResult[]>([]);
        const albums = signal<SearchResult[]>([]);
        const loading = signal(false);
        search.subscribe(q => {
            if (!q || q === "") {
                tracks.value = [];
                albums.value = [];
                return;
            }
            Api.searchTracks(q)
                .then(r => tracks.value = r)
                .finally(() => loading.value = false);
            Api.searchAlbums(q)
                .then(r => albums.value = r)
                .finally(() => loading.value = false);
        });
        const hasTracks = compute(t => t.length > 0, tracks);
        const hasAlbums = compute(a => a.length > 0, albums);

        return Generics.pageFrame(
            create("div")
                .classes("flex-v", "center-items")
                .children(
                    create("h1")
                        .classes("flex", "noflexwrap", "main-heading")
                        .children(
                            Generics.image("/images/color_logo.png", ["home-logo"]),
                            create("b").text("Tri").build(),
                            create("span").text("Records").build(),
                        ).build(),
                    Search.searchInput(search),
                    create("div")
                        .classes("flex", "width-divided")
                        .children(
                            ifjs(hasTracks, Search.results(tracks, "Tracks")),
                            ifjs(hasAlbums, Search.results(albums, "Albums"))
                        ).build()
                ).build(),
        );
    }
}